import { initSwiper } from '@resources/js/components/initSwiper';
import inViewport from '@resources/js/helpers/inViewport';
import hasHover from '@resources/js/helpers/hasHover';
import addSlidesToSlider from '@resources/js/helpers/addSlidesToSlider';
import Toggle from '@resources/js/ui/Toggle';
const DEFAULT_SLIDE_AMOUNT = 2;
const WIDE_LAYOUT_THRESHOLD = 2;
const BREAKPOINT_BASE = { spaceBetween: 32, touchStartPreventDefault: false };
const isHoverDevice = hasHover();
const sectionElements = document.querySelectorAll('.js-attraction-hotels-block');
sectionElements.forEach(sectionElement => {
    inViewport(sectionElement, () => {
        const sliderElement = sectionElement.querySelector('.js-slider-container');
        const slidesTablet = parseInt(sectionElement.dataset.slidesTablet, 10);
        initSwiper(sliderElement, {
            slidesPerView: 1.2,
            loop: false,
            spaceBetween: 16,
            breakpoints: slidesTablet > WIDE_LAYOUT_THRESHOLD
                ? {
                    768: Object.assign(Object.assign({}, BREAKPOINT_BASE), { slidesPerView: 2.1 }),
                    1200: Object.assign(Object.assign({}, BREAKPOINT_BASE), { slidesPerView: slidesTablet }),
                }
                : {
                    768: Object.assign(Object.assign({}, BREAKPOINT_BASE), { slidesPerView: DEFAULT_SLIDE_AMOUNT }),
                },
        });
        const slideElements = sliderElement.querySelectorAll('.js-slider-slide');
        const slideHeight = Math.max(...Array.from(slideElements).map(el => el.clientHeight));
        slideElements.forEach(slideElement => {
            slideElement.style.height = `${slideHeight}px`;
            const photoSliderElement = slideElement.querySelector('.js-photo-slider');
            if (!photoSliderElement)
                return;
            // Не ініціалізуємо свайпер для фото, коли <=1 фото
            if (Number(photoSliderElement.dataset.photoCount) <= 1)
                return;
            initSwiper(photoSliderElement, {
                loop: false,
                nested: true,
                spaceBetween: 4,
                allowTouchMove: !isHoverDevice,
                navigation: {
                    nextEl: slideElement.querySelector('.js-photo-next-btn'),
                    prevEl: slideElement.querySelector('.js-photo-prev-btn'),
                },
                pagination: {
                    el: slideElement.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: 3,
                },
            });
            photoSliderElement.swiper.once('slideChange', () => addSlidesToSlider(photoSliderElement, { width: 472, height: 312 }));
        });
        if (!isHoverDevice) {
            slideElements.forEach(slideElement => {
                const toggleElement = slideElement.querySelector('.js-toggle-description');
                const cardElement = slideElement.querySelector('.js-card');
                new Toggle(toggleElement, {
                    target: cardElement,
                    toggleClass: 'is-expanded',
                });
            });
        }
    });
});
